// extracted by mini-css-extract-plugin
export default {"base":"GTCDataCollectionPage_base__Opm-1","modal-sub-title":"GTCDataCollectionPage_modal-sub-title__QE-nw"};